{
  "v3.projet.action.created": "créé",
  "v3.projet.action.deleted": "supprimé",
  "v3.projet.action.status_changed": "statut changé",
  "v3.projet.action.updated": "modifié",
  "v3.projet.actualiser": "Actualiser",
  "v3.projet.annuler": "Annuler",
  "v3.projet.charte.appliquee": "Charte appliquée",
  "v3.projet.charte.aucune_surcharge": "Aucune surcharge sollicitée.",
  "v3.projet.charte.aucune_validee": "Aucune charte validée par l’organisation.",
  "v3.projet.charte.demander": "Demander une surcharge",
  "v3.projet.charte.imposee": "Charte de l’organisation imposée (version {{version}}).",
  "v3.projet.charte.recommandee": "Charte de l’organisation recommandée (version {{version}}).",
  "v3.projet.charte.retirer": "Retirer la sollicitation",
  "v3.projet.charte.revenir": "Revenir à la charte de l’organisation",
  "v3.projet.charte.revenir_effet": "La surcharge prend fin ; la charte de l’organisation s’applique de nouveau.",
  "v3.projet.charte.revenir_verbe": "Revenir",
  "v3.projet.charte.statut.active": "Accordée",
  "v3.projet.charte.statut.ended": "Terminée",
  "v3.projet.charte.statut.refused": "Refusée",
  "v3.projet.charte.statut.requested": "À décider par l’organisation",
  "v3.projet.charte.surcharge_accordee": "Surcharge du projet accordée : la charte du projet s’applique.",
  "v3.projet.charte.surcharges": "Surcharges sollicitées",
  "v3.projet.charte.titre": "Charte du projet",
  "v3.projet.choisir": "— Choisir —",
  "v3.projet.code.ALREADY_EXISTS": "Cet identifiant est déjà pris.",
  "v3.projet.code.CONFLIT_DE_VERSION": "Le projet a été modifié entre-temps : rechargez avant d’enregistrer.",
  "v3.projet.code.CONTEXTE_INCOMPLET": "Le contexte du projet est incomplet : la règle ne peut pas être évaluée.",
  "v3.projet.code.CORRESPONDANCE_PAQUET_REQUETE": "Le paquet ne correspond pas à la requête d’export : téléchargement refusé.",
  "v3.projet.code.CREATEUR_N_APPROUVE_PAS": "Vous êtes l’auteur : une autre personne doit décider.",
  "v3.projet.code.DESIGNATION_NON_MEMBRE": "Cette personne n’est pas membre du projet.",
  "v3.projet.code.DROIT_NON_TENU": "Vous ne tenez pas le droit requis pour ce geste.",
  "v3.projet.code.EXPORT_EXPIRE": "Ce lien d’export a expiré : demandez un nouvel export.",
  "v3.projet.code.EXPORT_INTROUVABLE": "Cet export est introuvable.",
  "v3.projet.code.IDEMPOTENCE_CONFLIT": "Cette demande a déjà été envoyée avec un autre contenu.",
  "v3.projet.code.INHERITED_REQUIREMENT_REMOVAL_REQUIRES_WAIVER": "Une règle héritée ne se retire pas : demandez une dérogation.",
  "v3.projet.code.MODELE_V10_INCOHERENT": "Le modèle du projet est incohérent : prévenez l’administration de l’organisation.",
  "v3.projet.code.NOM_DEJA_PRIS": "Ce nom est déjà pris par un autre projet de l’organisation.",
  "v3.projet.code.NOT_FOUND": "Cet objet est introuvable.",
  "v3.projet.code.PAQUET_NON_DISPONIBLE": "Le paquet de cet export n’est pas encore disponible.",
  "v3.projet.code.PROPOSITION_CADUQUE": "Cette proposition a été retirée ou a déjà reçu une réponse.",
  "v3.projet.code.PROPRIETAIRE_NON_MEMBRE": "Le propriétaire de la règle doit être membre du projet.",
  "v3.projet.code.PROPRIETAIRE_SEUL": "Seul le propriétaire du projet peut faire ce geste.",
  "v3.projet.code.QUOTA_AU_DELA_DU_PLAFOND": "Cette limite dépasse le plafond de l’organisation.",
  "v3.projet.code.RATTACHEMENT_DEJA_AILLEURS": "Le projet est déjà rattaché à un autre programme.",
  "v3.projet.code.REQUIREMENT_CODE_EXISTS": "Cet identifiant est déjà pris.",
  "v3.projet.code.REQUIREMENT_HAS_WAIVER_HISTORY": "Cette règle porte des dérogations : elle ne peut pas être retirée.",
  "v3.projet.code.RESOURCE_UNAVAILABLE": "Cet objet est indisponible.",
  "v3.projet.code.ROLE_HORS_MODELE": "Ce rôle n’est pas une désignation du modèle du projet.",
  "v3.projet.code.SANS_SESSION": "Votre session a expiré : reconnectez-vous.",
  "v3.projet.code.SUPPRESSION_DEJA_DEMANDEE": "Une suppression de ce projet est déjà demandée.",
  "v3.projet.code.VALIDATION_ERROR": "Une valeur saisie est refusée : vérifiez le formulaire.",
  "v3.projet.code.VERSION_CONFLICT": "Le projet a été modifié entre-temps : rechargez avant d’enregistrer.",
  "v3.projet.code.WAIVER_ALREADY_REVIEWED": "Cette dérogation a déjà été relue.",
  "v3.projet.code.WAIVER_COMPENSATING_CONTROLS_REQUIRED": "Au moins une mesure compensatoire est exigée.",
  "v3.projet.code.WAIVER_EXPIRY_REQUIRED": "L’échéance est obligatoire.",
  "v3.projet.code.WAIVER_RISK_CANNOT_BE_LOWERED": "La gravité ne peut pas être abaissée.",
  "v3.projet.code.WAIVER_SELF_REVIEW_REFUSED": "Vous avez demandé cette dérogation : une autre personne doit la relire.",
  "v3.projet.code.WORKSPACE_ARCHIVED": "Le projet est archivé : lecture seule.",
  "v3.projet.cycle.actif": "Projet actif.",
  "v3.projet.cycle.archive": "Projet archivé : lecture seule.",
  "v3.projet.cycle.archiver": "Archiver le projet",
  "v3.projet.cycle.archiver_effet": "Le projet passe en lecture seule pour tous ses membres.",
  "v3.projet.cycle.archiver_reversible": "Un désarchivage le rouvre.",
  "v3.projet.cycle.archiver_verbe": "Archiver",
  "v3.projet.cycle.aucune_suppression": "Aucune suppression sollicitée.",
  "v3.projet.cycle.demander_suppression": "Demander la suppression",
  "v3.projet.cycle.desarchiver": "Désarchiver le projet",
  "v3.projet.cycle.etat": "État du projet",
  "v3.projet.cycle.sollicitee": "Suppression sollicitée le {{date}} par {{par}} : l’organisation décidera.",
  "v3.projet.cycle.suppression": "Suppression",
  "v3.projet.cycle.transferer": "Transférer la propriété",
  "v3.projet.derogation.deja": "déjà dérogée",
  "v3.projet.derogation.demander": "Demander l’approbation",
  "v3.projet.derogation.expire": "Expire le",
  "v3.projet.derogation.expire_validation": "L’échéance doit être future et à un an au plus.",
  "v3.projet.derogation.gravite": "Niveau de gravité",
  "v3.projet.derogation.gravite_critical": "Critique",
  "v3.projet.derogation.gravite_high": "Élevé",
  "v3.projet.derogation.gravite_low": "Faible",
  "v3.projet.derogation.gravite_medium": "Moyen",
  "v3.projet.derogation.justification": "Justification",
  "v3.projet.derogation.mesures": "Mesures compensatoires (une par ligne)",
  "v3.projet.derogation.regle": "Règle visée",
  "v3.projet.derogation.suite": "La dérogation est relue dans le projet puis décidée par l’organisation.",
  "v3.projet.derogation.titre": "Demander une dérogation au référentiel",
  "v3.projet.designation.aucun_role": "Aucun rôle à désigner dans ce projet.",
  "v3.projet.designation.designer": "Désigner",
  "v3.projet.designation.exige_manquant": "{{role}} (exigé, manquant)",
  "v3.projet.designation.journal": "La désignation est écrite au journal.",
  "v3.projet.designation.personne": "Personne",
  "v3.projet.designation.remplace": "Remplace la désignation de {{qui}} ; écrit au journal.",
  "v3.projet.designation.role": "Rôle",
  "v3.projet.designation.roles": "Rôles du projet",
  "v3.projet.designation.titre": "Désigner une personne pour un rôle du projet",
  "v3.projet.equipe.a_ajouter": "Membre à ajouter",
  "v3.projet.equipe.ajouter": "Ajouter à l’équipe",
  "v3.projet.equipe.assignes": "{{n}} éléments assignés",
  "v3.projet.equipe.aucun_membre": "Aucun membre dans cette équipe.",
  "v3.projet.equipe.aucun_travail": "Aucun travail rangé.",
  "v3.projet.equipe.capacite_jours": "{{n}} jours-personne",
  "v3.projet.equipe.capacite_points": "{{n}} points",
  "v3.projet.equipe.charge": "Cadence {{cadence}} : {{points}} points engagés, capacité {{capacite}}.",
  "v3.projet.equipe.creer": "Créer l’équipe",
  "v3.projet.equipe.creer_titre": "Créer une équipe du projet",
  "v3.projet.equipe.effet_membres": "{{n}} membre(s) restent membres du projet.",
  "v3.projet.equipe.effet_travail": "Le travail rangé de « {{nom}} » ({{n}} éléments) reste dans le projet, sans équipe.",
  "v3.projet.equipe.fiche": "Équipe du projet — fiche",
  "v3.projet.equipe.introuvable": "Équipe introuvable.",
  "v3.projet.equipe.membres": "Membres de l’équipe",
  "v3.projet.equipe.nom": "Nom de l’équipe",
  "v3.projet.equipe.retirer": "Retirer {{nom}} de l’équipe",
  "v3.projet.equipe.sans_cadence": "Aucune cadence active pour cette équipe.",
  "v3.projet.equipe.supprimer": "Supprimer l’équipe",
  "v3.projet.equipe.supprimer_titre": "Supprimer une équipe — confirmation",
  "v3.projet.equipe.tous_les_membres": "Tous les membres du projet",
  "v3.projet.equipe.travail": "Travail rangé",
  "v3.projet.etape.a_venir": "à venir",
  "v3.projet.etape.en_cours": "en cours",
  "v3.projet.etape.faite": "faite",
  "v3.projet.etape.franchie": "franchie",
  "v3.projet.etape.non_activee": "non activée",
  "v3.projet.etape.rouverte": "rouverte",
  "v3.projet.etat.chargement": "Chargement de {{quoi}}…",
  "v3.projet.etat.erreur": "{{quoi}} : lecture impossible pour le moment.",
  "v3.projet.etat.reessayer": "Réessayer",
  "v3.projet.etat.refus": "{{quoi}} : vous n’avez pas accès à cette information.",
  "v3.projet.export.aucun": "Aucun export gouverné.",
  "v3.projet.export.auteur": "Auteur",
  "v3.projet.export.contenu": "Contenu exporté",
  "v3.projet.export.demande": "Export gouverné demandé.",
  "v3.projet.export.demander": "Demander un export gouverné",
  "v3.projet.export.empreinte": "Empreinte",
  "v3.projet.export.espace": "Archive complète du projet",
  "v3.projet.export.espace_aide": "Télécharge tout le projet, pour une sauvegarde du propriétaire.",
  "v3.projet.export.etat": "État",
  "v3.projet.export.etat_active": "actif",
  "v3.projet.export.etat_expired": "expiré",
  "v3.projet.export.exclusions": "Exclusions : {{liste}}",
  "v3.projet.export.expire_le": "expire le {{date}}",
  "v3.projet.export.exporter": "Exporter l’espace",
  "v3.projet.export.fiche": "Détail d’un export gouverné",
  "v3.projet.export.finalite": "Finalité",
  "v3.projet.export.finalite_partage_pseudonymise": "Partage pseudonymisé",
  "v3.projet.export.finalite_sauvegarde_proprietaire": "Sauvegarde du propriétaire",
  "v3.projet.export.gouverne": "Exports gouvernés",
  "v3.projet.export.heures": "{{n}} heures",
  "v3.projet.export.lien_depuis_fiche": "Le lien à usage unique s’émet depuis la fiche de l’export.",
  "v3.projet.export.lien_emis": "Lien à usage unique émis.",
  "v3.projet.export.liens": "Liens",
  "v3.projet.export.liens_valeur": "{{emis}} émis, {{utilises}} utilisés",
  "v3.projet.export.numero": "Export n° {{id}}",
  "v3.projet.export.perimetre": "Public (droits v10)",
  "v3.projet.export.provenance": "Provenance",
  "v3.projet.export.public": "Public",
  "v3.projet.export.public_contributor": "Contributeurs",
  "v3.projet.export.public_owner": "Propriétaires",
  "v3.projet.export.public_viewer": "Lecteurs",
  "v3.projet.export.retention": "Rétention",
  "v3.projet.export.retour": "Retour aux exports",
  "v3.projet.export.signature": "Signature",
  "v3.projet.export.telecharge": "Archive téléchargée.",
  "v3.projet.export.telecharge_le": "téléchargé le {{date}}",
  "v3.projet.export.telecharger": "Télécharger",
  "v3.projet.export.telecharger_depuis_fiche": "Le téléchargement se fait depuis la fiche de l’export, par un lien à usage unique.",
  "v3.projet.export.titre": "Export du projet",
  "v3.projet.geste.enregistre": "Modification enregistrée.",
  "v3.projet.geste.erreur": "Le geste n’a pas abouti. Réessayez dans un instant.",
  "v3.projet.indicateurs.aucune_tranche": "Aucune tranche prête.",
  "v3.projet.indicateurs.budget_erreur": "Budget d’erreur",
  "v3.projet.indicateurs.choisir_tranche": "Choisissez une tranche pour la détailler.",
  "v3.projet.indicateurs.consommation": "Consommation IA",
  "v3.projet.indicateurs.delai": "Délai de livraison",
  "v3.projet.indicateurs.detail": "Détail des signaux",
  "v3.projet.indicateurs.detail_signaux": "Le détail d’un signal se lit dans son bloc, sans nouvel appel.",
  "v3.projet.indicateurs.efficacite": "Efficacité des agents",
  "v3.projet.indicateurs.jours": "{{n}} jours",
  "v3.projet.indicateurs.mesure": "Mesure",
  "v3.projet.indicateurs.obstacles": "Obstacles de la cadence",
  "v3.projet.indicateurs.periode": "Période",
  "v3.projet.indicateurs.reessayer_bloc": "Chaque bloc en erreur se relit seul par son bouton Réessayer.",
  "v3.projet.indicateurs.sante": "Santé calculée du projet",
  "v3.projet.indicateurs.seuils": "Seuils : {{liste}}",
  "v3.projet.indicateurs.signal": "Signal",
  "v3.projet.indicateurs.statistiques": "Statistiques du backlog",
  "v3.projet.indicateurs.tableau": "Afficher en tableau",
  "v3.projet.indicateurs.tableau_de_bord": "Tableau de bord",
  "v3.projet.indicateurs.titre": "Indicateurs du projet",
  "v3.projet.indicateurs.tranche_choisie": "Tranche choisie",
  "v3.projet.indicateurs.tranches": "Tranches prêtes à construire",
  "v3.projet.indicateurs.valeur": "Valeur",
  "v3.projet.indicateurs.vide": "Aucune donnée pour ce bloc.",
  "v3.projet.integrations.activer_webhook": "Activer {{nom}}",
  "v3.projet.integrations.actualiser": "Actualiser les données",
  "v3.projet.integrations.aucun_webhook": "Aucun webhook public.",
  "v3.projet.integrations.branches": "Branches",
  "v3.projet.integrations.connecter": "Connecter",
  "v3.projet.integrations.connecter_odoo": "Connecter Odoo",
  "v3.projet.integrations.creer_partenaire": "Créer un partenaire",
  "v3.projet.integrations.creer_webhook": "Créer un webhook",
  "v3.projet.integrations.declencher": "Déclencher un pipeline relève du responsable des mises en production, jamais des intégrations.",
  "v3.projet.integrations.depot": "Dépôt GitLab",
  "v3.projet.integrations.depot_absent": "Aucun dépôt connecté.",
  "v3.projet.integrations.depot_connecte": "Connecté à {{url}} (projet {{depot}}).",
  "v3.projet.integrations.desactiver": "Désactiver",
  "v3.projet.integrations.desactiver_effet": "Les événements reçus ne déclencheront plus rien.",
  "v3.projet.integrations.desactiver_webhook": "Désactiver {{nom}}",
  "v3.projet.integrations.etapes": "Étapes du pipeline #{{id}}",
  "v3.projet.integrations.evenements": "{{n}} événements reçus, dernier : {{dernier}}",
  "v3.projet.integrations.fusions": "Fusions proposées",
  "v3.projet.integrations.https": "L’adresse doit commencer par https://",
  "v3.projet.integrations.injoignable": "Connexion injoignable : {{motif}}",
  "v3.projet.integrations.jeton": "Jeton d’accès",
  "v3.projet.integrations.jeton_aide": "Facultatif pour un projet public ; jamais réaffiché.",
  "v3.projet.integrations.joignable": "Connexion joignable.",
  "v3.projet.integrations.liste_sans_depot": "Lu une fois un dépôt connecté.",
  "v3.projet.integrations.liste_vide": "Rien à montrer.",
  "v3.projet.integrations.odoo": "Odoo",
  "v3.projet.integrations.odoo_absent": "Odoo n’est pas connecté.",
  "v3.projet.integrations.odoo_base": "Base Odoo",
  "v3.projet.integrations.odoo_instance": "Instance Odoo",
  "v3.projet.integrations.odoo_login": "Identifiant Odoo",
  "v3.projet.integrations.odoo_secret": "Mot de passe Odoo",
  "v3.projet.integrations.partenaire": "Nom du partenaire",
  "v3.projet.integrations.pipelines": "Pipelines récents",
  "v3.projet.integrations.projet_depot": "Projet du dépôt",
  "v3.projet.integrations.supprimer": "Supprimer la connexion",
  "v3.projet.integrations.supprimer_effet": "Les pipelines, fusions et branches ne seront plus lus.",
  "v3.projet.integrations.tester": "Tester la connexion",
  "v3.projet.integrations.tester_odoo": "Tester Odoo",
  "v3.projet.integrations.trace": "Trace de l’étape",
  "v3.projet.integrations.trace_masquee": "Choisissez une étape pour déplier sa trace.",
  "v3.projet.integrations.url": "Adresse de l’instance",
  "v3.projet.integrations.webhooks": "Webhooks publics",
  "v3.projet.methode.artefacts": "Types d’artefacts",
  "v3.projet.methode.deroule": "Déroulé du modèle",
  "v3.projet.methode.lancer": "Lancer un processus",
  "v3.projet.methode.modele": "Modèle de l’espace",
  "v3.projet.methode.objets": "Chaîne des objets",
  "v3.projet.methode.sans_modele": "Ce projet n’a pas de modèle figé : aucun déroulé à montrer.",
  "v3.projet.methode.titre": "Vue projet — méthode et processus",
  "v3.projet.methode.workflows": "Workflows et rôles d’agent",
  "v3.projet.modele.aucun": "Aucun modèle figé pour ce projet.",
  "v3.projet.modele.fige": "Modèle {{modele}}, version {{version}}, figé à la création du projet.",
  "v3.projet.modele.jamais_migre": "Un projet ne change jamais de modèle : un nouveau projet le fait.",
  "v3.projet.modeles.a_autoriser": "Modèle à autoriser",
  "v3.projet.modeles.agent_autorise": "autorisé dans le projet",
  "v3.projet.modeles.agent_non_autorise": "non autorisé",
  "v3.projet.modeles.agents": "Agents de l’organisation",
  "v3.projet.modeles.aucun_agent": "Aucun agent dans l’organisation.",
  "v3.projet.modeles.autoriser": "Autoriser ce modèle",
  "v3.projet.modeles.autoriser_agent": "Autoriser l’agent {{nom}}",
  "v3.projet.modeles.retirer": "Retirer le modèle {{nom}}",
  "v3.projet.modeles.retirer_agent": "Retirer l’agent {{nom}}",
  "v3.projet.modeles.retirer_effet": "{{n}} agents du projet utilisent ce modèle et devront en changer.",
  "v3.projet.modeles.titre": "Modèles autorisés",
  "v3.projet.modeles.utilise_par": "Utilisé par {{n}} agents",
  "v3.projet.modeles.vide": "Aucun modèle n’est autorisé dans ce projet.",
  "v3.projet.motif": "Motif",
  "v3.projet.nature.access_request_to_decide": "Demande d’accès en attente",
  "v3.projet.nature.designation_missing": "Désignation exigée manquante",
  "v3.projet.nature.launch_to_finish": "Lancement à terminer",
  "v3.projet.nature.quota_over_threshold": "Quota au-delà de 80 %",
  "v3.projet.nature.technology_change_to_decide": "Changement technologique à décider",
  "v3.projet.nature.waiver_to_review": "Dérogation à relire",
  "v3.projet.onglet.activite": "Activité",
  "v3.projet.onglet.apercu": "Aperçu",
  "v3.projet.onglet.configuration": "Configuration",
  "v3.projet.onglet.cycle": "Cycle de vie",
  "v3.projet.onglet.indicateurs": "Indicateurs",
  "v3.projet.onglet.integrations": "Intégrations",
  "v3.projet.onglet.membres": "Membres",
  "v3.projet.onglet.methode": "Méthode et processus",
  "v3.projet.onglet.modeles": "Modèles et agents autorisés",
  "v3.projet.onglet.quotas": "Quotas",
  "v3.projet.onglets.reglages": "Sections des réglages du projet",
  "v3.projet.onglets.vue": "Vues du projet",
  "v3.projet.options.membres": "Membres du projet",
  "v3.projet.quotas.avertissement": "au-delà de 80 %",
  "v3.projet.quotas.bloquees": "Les générations sont bloquées : une limite est atteinte.",
  "v3.projet.quotas.enregistrer": "Enregistrer la limite",
  "v3.projet.quotas.limite": "Limite",
  "v3.projet.quotas.par_consommation": "Consommation",
  "v3.projet.quotas.par_ressource": "Ressource",
  "v3.projet.quotas.plafond": "plafond de l’organisation {{n}}",
  "v3.projet.quotas.remettre": "Remettre à zéro",
  "v3.projet.quotas.remettre_effet": "La consommation de la ressource repart de zéro.",
  "v3.projet.quotas.ressource.document_size_mb": "Taille d’un document (Mio)",
  "v3.projet.quotas.ressource.documents_count": "Nombre de documents",
  "v3.projet.quotas.ressource.generations": "Générations",
  "v3.projet.quotas.ressource.requests_per_minute": "Requêtes par minute",
  "v3.projet.quotas.ressource.storage": "Stockage",
  "v3.projet.quotas.ressource.tokens": "Jetons",
  "v3.projet.quotas.ressource.tokens_per_day": "Jetons par jour",
  "v3.projet.quotas.ressource_choisie": "Ressource",
  "v3.projet.quotas.retirer": "Retirer la limite",
  "v3.projet.quotas.retirer_effet": "La ressource n’aura plus de limite propre au projet.",
  "v3.projet.quotas.titre": "Quotas du projet",
  "v3.projet.quotas.trier": "Trier par",
  "v3.projet.quotas.vide": "Aucun quota pour ce projet.",
  "v3.projet.referentiel.absente": "Règles absentes : {{codes}}",
  "v3.projet.referentiel.ajouter": "Ajouter une règle",
  "v3.projet.referentiel.appliquer": "Appliquer",
  "v3.projet.referentiel.appliquer_mode": "Appliquer le mode",
  "v3.projet.referentiel.appliquer_verbe": "Appliquer",
  "v3.projet.referentiel.approuver": "Approuver la relecture",
  "v3.projet.referentiel.aucune_derogation": "Aucune dérogation.",
  "v3.projet.referentiel.aucune_regle": "Aucune règle ne s’applique à ce projet.",
  "v3.projet.referentiel.choisir_derogation": "Choisissez une dérogation pour la détailler.",
  "v3.projet.referentiel.choisir_regle": "Choisissez une règle pour la détailler.",
  "v3.projet.referentiel.commentaire": "Commentaire de relecture",
  "v3.projet.referentiel.contenu": "Contenu à vérifier",
  "v3.projet.referentiel.decision_organisation": "La décision sur une dérogation revient à l’organisation.",
  "v3.projet.referentiel.demander_derogation": "Demander une dérogation",
  "v3.projet.referentiel.derogation.expired": "échue",
  "v3.projet.referentiel.derogation.granted": "accordée",
  "v3.projet.referentiel.derogation.lifted": "levée",
  "v3.projet.referentiel.derogation.refused": "refusée",
  "v3.projet.referentiel.derogation.requested": "demandée",
  "v3.projet.referentiel.derogation_detail": "Risque {{risque}} · mesures : {{mesures}} · échéance {{echeance}} · demandée par {{auteur}}",
  "v3.projet.referentiel.derogations": "Dérogations du projet",
  "v3.projet.referentiel.detail": "Catégorie {{categorie}} · contrôle {{controle}} · propriétaire {{proprietaire}}",
  "v3.projet.referentiel.deux_personnes": "Mode deux personnes",
  "v3.projet.referentiel.deux_personnes_actif": "Mode deux personnes actif : une seconde personne valide les objets de risque {{risque}} et au-delà.",
  "v3.projet.referentiel.deux_personnes_inactif": "Mode deux personnes désactivé.",
  "v3.projet.referentiel.effet_enforce": "Une règle manquante bloquera les livrables du projet.",
  "v3.projet.referentiel.effet_observe": "Les règles manquantes seront signalées sans bloquer (jamais plus faible que l’organisation).",
  "v3.projet.referentiel.etat.a_verifier": "à vérifier",
  "v3.projet.referentiel.etat.conforme": "conforme",
  "v3.projet.referentiel.etat.en_derogation": "en dérogation",
  "v3.projet.referentiel.etat.non_conforme": "non conforme",
  "v3.projet.referentiel.etat.perimee": "périmée",
  "v3.projet.referentiel.fiche_derogation": "Fiche de la dérogation",
  "v3.projet.referentiel.fiche_regle": "Fiche de la règle",
  "v3.projet.referentiel.heritee": "héritée",
  "v3.projet.referentiel.mode": "Mode d’application",
  "v3.projet.referentiel.observer": "Observer",
  "v3.projet.referentiel.presente": "Toutes les règles sont présentes.",
  "v3.projet.referentiel.propre": "propre au projet",
  "v3.projet.referentiel.regles": "Règles",
  "v3.projet.referentiel.rejeter": "Rejeter",
  "v3.projet.referentiel.relue": "Relecture enregistrée : l’organisation décidera.",
  "v3.projet.referentiel.relue_par": "Relue par {{qui}}",
  "v3.projet.referentiel.retirer": "Retirer la règle du projet",
  "v3.projet.referentiel.retirer_effet": "La règle {{code}} ne s’appliquera plus à ce projet.",
  "v3.projet.referentiel.titre": "Référentiel hérité du projet",
  "v3.projet.referentiel.verifier": "Vérifier la présence",
  "v3.projet.reglages.charte": "Charte du projet",
  "v3.projet.reglages.description": "Description",
  "v3.projet.reglages.enregistre": "Modification enregistrée.",
  "v3.projet.reglages.enregistrer": "Enregistrer",
  "v3.projet.reglages.gouvernance": "Gouvernance du projet",
  "v3.projet.reglages.identite": "Identité du projet",
  "v3.projet.reglages.methode": "Méthode et processus",
  "v3.projet.reglages.modele": "Modèle du projet",
  "v3.projet.reglages.nom": "Nom du projet",
  "v3.projet.reglages.nom_validation": "Entre 3 et 255 caractères.",
  "v3.projet.reglages.renommer": "Renommer",
  "v3.projet.reglages.rien_a_enregistrer": "Rien à enregistrer : aucune valeur n’a changé.",
  "v3.projet.reglages.sections": "Sections accessibles",
  "v3.projet.reglages.sections_aide": "Chaque section s’ouvre à qui peut y agir ; chaque commande vérifie son droit.",
  "v3.projet.reglages.titre": "Réglages du projet",
  "v3.projet.regle.ajouter": "Ajouter la règle",
  "v3.projet.regle.ajouter_critere": "Ajouter comme critère de fin",
  "v3.projet.regle.categorie": "Catégorie",
  "v3.projet.regle.critere": "Critère (seuil, facultatif)",
  "v3.projet.regle.enonce": "Énoncé",
  "v3.projet.regle.identifiant": "Identifiant",
  "v3.projet.regle.preuve": "Moyen de preuve",
  "v3.projet.regle.proprietaire": "Propriétaire",
  "v3.projet.regle.titre": "Ajouter une règle propre au projet",
  "v3.projet.retirer": "Retirer",
  "v3.projet.retour_vue": "Retour à la vue du projet",
  "v3.projet.sans_projet": "Choisissez d’abord un projet dans la barre de contexte.",
  "v3.projet.sante.a_risque": "À risque",
  "v3.projet.sante.en_bonne_voie": "En bonne voie",
  "v3.projet.sante.hors_trajectoire": "Hors trajectoire",
  "v3.projet.sante.indicateur": "Indicateur de santé",
  "v3.projet.sante.publier": "Publier",
  "v3.projet.sante.texte": "Texte de la mise à jour",
  "v3.projet.sante.titre": "Publier la santé du projet",
  "v3.projet.suppression.effet_differee": "L’organisation décide et programme une suppression différée.",
  "v3.projet.suppression.effet_export": "Exportez d’abord le projet si vous voulez en garder une copie.",
  "v3.projet.suppression.envoyer": "Envoyer la sollicitation",
  "v3.projet.suppression.motif_validation": "Au moins 15 caractères.",
  "v3.projet.suppression.titre": "Suppression du projet par l’organisation — sollicitation",
  "v3.projet.supprimer": "Supprimer",
  "v3.projet.surcharge.demander": "Demander la dérogation",
  "v3.projet.surcharge.ecarts": "Écarts à la charte",
  "v3.projet.surcharge.suite": "Charte recommandée : la surcharge est tracée. Charte imposée : l’organisation décide.",
  "v3.projet.surcharge.titre": "Demander une surcharge de la charte",
  "v3.projet.vue.a_traiter": "À traiter par le propriétaire",
  "v3.projet.vue.accepter_rattachement": "Accepter le rattachement",
  "v3.projet.vue.activite": "Activité récente",
  "v3.projet.vue.application_a_recetter": "Application à recetter",
  "v3.projet.vue.aucun_indicateur": "Aucun indicateur disponible.",
  "v3.projet.vue.aucun_proprietaire": "Aucun propriétaire nommé",
  "v3.projet.vue.aucun_rattachement": "Aucun rattachement proposé.",
  "v3.projet.vue.aucune_activite": "Aucune activité récente.",
  "v3.projet.vue.aucune_etape": "Aucune étape dans le cycle.",
  "v3.projet.vue.aucune_sante": "Aucune mise à jour de santé publiée.",
  "v3.projet.vue.comprendre": "Comprendre un refus et demander un accès",
  "v3.projet.vue.cycle": "Avancement du cycle",
  "v3.projet.vue.decider_acces": "Décider les accès sollicités",
  "v3.projet.vue.description": "Description",
  "v3.projet.vue.droits_gagnes": "Le programme gagnerait : {{droits}}",
  "v3.projet.vue.executer_etape": "Exécuter une étape",
  "v3.projet.vue.exporter": "Exporter le projet",
  "v3.projet.vue.identite": "Identité du projet",
  "v3.projet.vue.indicateurs": "Indicateurs du projet",
  "v3.projet.vue.motif_refus": "Motif du refus (facultatif)",
  "v3.projet.vue.nom": "Nom",
  "v3.projet.vue.ouvrir_changements": "Ouvrir les changements",
  "v3.projet.vue.ouvrir_reglages": "Ouvrir les réglages",
  "v3.projet.vue.programme": "Programme",
  "v3.projet.vue.proprietaires": "Propriétaire",
  "v3.projet.vue.publie_par": "Publiée par {{qui}} le {{date}}",
  "v3.projet.vue.publier_sante": "Publier la santé",
  "v3.projet.vue.rattachement": "Rattachement proposé",
  "v3.projet.vue.rattachement_accepte": "Rattachement accepté.",
  "v3.projet.vue.rattachement_propose": "Le programme {{programme}} propose de rattacher ce projet (demandé par {{demandeur}} le {{date}}).",
  "v3.projet.vue.rattachement_refuse": "Rattachement refusé.",
  "v3.projet.vue.refuser_rattachement": "Refuser le rattachement",
  "v3.projet.vue.rien_a_traiter": "Rien n’attend le propriétaire.",
  "v3.projet.vue.sans_description": "Sans description.",
  "v3.projet.vue.sans_programme": "Rattaché à aucun programme",
  "v3.projet.vue.sante": "Santé publiée",
  "v3.projet.vue.suppression_programmee": "Suppression programmée par l’organisation : purge après le {{date}}.",
  "v3.projet.vue.terminer_lancement": "Terminer le lancement",
  "v3.projet.vue.titre": "Vue projet",
  "v3.projet.webhook.copie": "J’ai copié le secret",
  "v3.projet.webhook.copier": "Copier l’adresse",
  "v3.projet.webhook.creer": "Créer le webhook",
  "v3.projet.webhook.nom": "Nom",
  "v3.projet.webhook.secret_une_fois": "Secret du webhook, montré une seule fois : copiez-le maintenant.",
  "v3.projet.webhook.titre": "Créer un webhook public du projet",
  "v3.projet.webhook.type": "Type d’événement",
  "v3.projet.webhook.type_generic": "Générique",
  "v3.projet.webhook.type_gitlab_merge_request": "Fusion GitLab",
  "v3.projet.webhook.type_gitlab_pipeline": "Pipeline GitLab",
  "v3.projet.webhook.type_gitlab_push": "Poussée GitLab",
  "v3.projet.webhook.workflow": "Workflow déclenché (facultatif)"
}
